<template>
    <div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb class="bnone">
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>物流查询</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
                 status-icon>
            <el-form-item label="是否开启">
                <el-switch v-model="item.open" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#cccccc">
                </el-switch>
            </el-form-item>
            <el-divider content-position="left">快递100</el-divider>
            <el-form-item label="快递100 Customer">
                <el-input v-model="item.engine.kuaidi100.customer"></el-input>
            </el-form-item>
            <el-form-item label="快递100 Ke">
                <el-input v-model="item.engine.kuaidi100.key"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                shareThumb: []
            }
        },
        created() {
            this.loadItem()
        },
        methods: {
            loadItem() {
                if (this.isLoad)
                    return
                this.axios.post('/store/setting/detail',{
                    'key': 'expressapi',

                })
                .then(async (res) => {
                    this.loading = false;
                    if (res.code == 1 && res.data.values) {
                        this.item = res.data.values
                    } else {
                        this.loading = false;
                        this.$Message.error(res.msg);
                    }
                })
            },
            submit() {
                if (this.isLoad)
                    return
                this.axios.post('/store/setting/update',{
                    'key': 'expressapi',
                    form: this.item,
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.$message.success(res.msg);
                    } else {
                        this.loading = false;
                        this.$message.error(res.msg);
                    }
                })
                .catch((res) => {
                    this.loading = false;
                });
            },
        }
    }
</script>
<style>
</style>
